/**
 * resolveCtaClick — shared helper used by Primary / Secondary / Final CTA
 * sections to honour the admin's CMS "Button Action" choice.
 *
 * cta.action_type === 'scroll' → smooth-scroll to the section with the
 *                                given data-section / id attribute.
 *                                If target === 'pricing' AND prefill_weeks is
 *                                set, also broadcasts a `pricing-prefill`
 *                                window event so the slider can position
 *                                itself before the visitor arrives.
 * otherwise                    → fall back to the goToSignup callback
 *                                (default — preserves legacy behaviour)
 */
/**
 * signalPricingCtaArrival — broadcast that a CTA has just sent the visitor
 * to the Pricing section. The PricingSliderSection listens for this and:
 *   • always plays the thumb-pulse animation (draws the eye to the slider);
 *   • additionally snaps the slider to `prefillWeeks` and reveals the totals
 *     when the admin set a prefill on this CTA.
 * No-op for non-pricing scroll targets.
 */
export function signalPricingCtaArrival(target, prefillWeeks) {
  if (target !== 'pricing') return;
  const w = Number(prefillWeeks);
  const detail = (Number.isFinite(w) && w >= 1 && w <= 52) ? { weeks: w } : {};
  if (detail.weeks != null) {
    try { sessionStorage.setItem('pricingPrefillWeeks', String(detail.weeks)); } catch { /* private-mode safe */ }
  }
  window.dispatchEvent(new CustomEvent('pricing-cta-arrived', { detail }));
}

export function resolveCtaClick(cta, goToSignup) {
  if (!cta) { goToSignup?.(); return; }
  if (cta.action_type === 'scroll') {
    // Fall back to 'pricing' when scroll_target wasn't persisted (older CMS
    // saves committed action_type without picking a target, leaving the
    // dropdown's visual default of 'Pricing' uncommitted to the DB).
    const target = cta.scroll_target || 'pricing';
    const el =
      document.getElementById(target) ||
      document.querySelector(`[data-section="${target}"]`);
    if (el) {
      signalPricingCtaArrival(target, cta.prefill_weeks);
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
  }
  goToSignup?.();
}
